import React from "react";
import EyebrowAndTitle from "./EyebrowAndTitle";
import StickyTitleWithImage from "./StickyTitleWithImage";
import TitleAndTwoColumnsBelow from "./TitleAndTwoColumnsBelow";
import TitleAndRightColumn from "./TitleAndRightColumn";
import DescriptionWithClientLogos from "./DescriptionWithClientLogos";
import HalfWidth from "./HalfWidth";
import FullWidth from "./FullWidth";
import TwoColumnWithImage from "./TwoColumnWithImage";

function ContentArea({
  eyebrow,
  title,
  description,
  subDescription,
  image,
  alignment,
  id,
  ctaUrl,
  ctaLabel,
  ctaChatbotIdentifier,
  backgroundColour,
  isSticky,
  video,
  clientLogos,
  layout,
  hideTitle,
  hideIndexNumberDisplay,
  anchorId,
  hasBottomMargin,
  hasTopMargin,
}) {
  if (layout === "Half width") {
    return (
      <HalfWidth
        eyebrow={eyebrow}
        title={title}
        description={description}
        alignment={alignment}
        hideTitle={hideTitle}
        hasBottomMargin={hasBottomMargin}
        hasTopMargin={hasTopMargin}
      />
    );
  }

  if (layout === "Full width") {
    return (
      <FullWidth
        eyebrow={eyebrow}
        title={title}
        description={description}
        hideTitle={hideTitle}
        hasBottomMargin={hasBottomMargin}
        hasTopMargin={hasTopMargin}
      />
    );
  }

  if (layout === "Description with client logos") {
    return (
      <DescriptionWithClientLogos
        description={description}
        image={image}
        title={title}
        clientLogos={clientLogos}
        hideTitle={hideTitle}
        hasBottomMargin={hasBottomMargin}
        hasTopMargin={hasTopMargin}
      />
    );
  }

  if (layout === "Eyebrow and title") {
    return (
      <EyebrowAndTitle
        eyebrow={eyebrow}
        title={title}
        alignment={alignment}
        ctaUrl={ctaUrl}
        ctaLabel={ctaLabel}
        isSticky={isSticky}
        hideTitle={hideTitle}
        hasBottomMargin={hasBottomMargin}
        hasTopMargin={hasTopMargin}
        backgroundColour={backgroundColour}
      />
    );
  }

  if (layout === "Title and right column") {
    return (
      <TitleAndRightColumn
        eyebrow={eyebrow}
        title={title}
        description={description}
        backgroundColour={backgroundColour}
        isSticky={isSticky}
        hideTitle={hideTitle}
        ctaUrl={ctaUrl}
        ctaLabel={ctaLabel}
        hasBottomMargin={hasBottomMargin}
        hasTopMargin={hasTopMargin}
      />
    );
  }

  if (layout === "Sticky title with image") {
    return (
      <StickyTitleWithImage
        eyebrow={eyebrow}
        title={title}
        image={image}
        alignment={alignment}
        backgroundColour={backgroundColour}
        id={id}
        anchorId={anchorId}
        video={video}
        hideTitle={hideTitle}
        hasBottomMargin={hasBottomMargin}
        hasTopMargin={hasTopMargin}
      />
    );
  }

  if (layout === "Title and two columns below") {
    return (
      <TitleAndTwoColumnsBelow
        eyebrow={eyebrow}
        title={title}
        description={description}
        subDescription={subDescription}
        hideTitle={hideTitle}
        hideIndexNumberDisplay={hideIndexNumberDisplay}
        hasBottomMargin={hasBottomMargin}
        hasTopMargin={hasTopMargin}
        backgroundColour={backgroundColour}
      />
    );
  }
  if (
    layout === "Left image and right content" ||
    layout === "Right image and left content"
  ) {
    return (
      <TwoColumnWithImage
        eyebrow={eyebrow}
        title={title}
        image={image}
        alignment={alignment}
        backgroundColour={backgroundColour}
        id={id}
        anchorId={anchorId}
        video={video}
        hideTitle={hideTitle}
        description={description}
        subDescription={subDescription}
        ctaUrl={ctaUrl}
        ctaLabel={ctaLabel}
        ctaChatbotIdentifier={ctaChatbotIdentifier}
        imageRight={layout === "Right image and left content"}
        hasBottomMargin={hasBottomMargin}
        hasTopMargin={hasTopMargin}
      />
    );
  }

  console.warn(`No ContentArea layout available for "${layout}" (${title})`);
  return null;
}

export default ContentArea;
